// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"60c70cf3","216":"f1a73f7c"}[chunkId] + ".chunk.js";
};